import { useCallback, useEffect, useState } from "react";
import { api } from "@/api";

function todayMonthKey() {
  const t = new Date();
  return `${String(t.getFullYear() % 100).padStart(2, "0")} ${String(t.getMonth() + 1).padStart(2, "0")}`;
}

export function useMonths(currentKeyRef) {
  const [months, setMonths] = useState([]);
  const [currentKey, setCurrentKey] = useState(null);
  const [monthInfo, setMonthInfo] = useState(null);

  const loadMonths = useCallback(async () => {
    const res = await api.get("/months");
    setMonths(res.data);
    const cur = currentKeyRef.current;
    if (!res.data.length) { setCurrentKey(null); return; }
    if (!cur) {
      // all'apertura mostra il mese corrente se esiste, altrimenti l'ultimo disponibile
      const today = res.data.find((m) => m.key === todayMonthKey());
      setCurrentKey((today || res.data[res.data.length - 1]).key);
    } else if (!res.data.some((m) => m.key === cur)) {
      setCurrentKey(res.data[res.data.length - 1].key);
    }
    // api è un import di modulo stabile: deps intenzionalmente limitate
  }, [currentKeyRef]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { loadMonths(); }, [loadMonths]);

  useEffect(() => {
    if (!currentKey) { setMonthInfo(null); return; }
    api.get(`/months/${encodeURIComponent(currentKey)}`)
      .then((r) => setMonthInfo(r.data))
      .catch(() => setMonthInfo(null));
    // api ed encodeURIComponent sono stabili (modulo/global): deps limitate a currentKey
  }, [currentKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return { months, currentKey, setCurrentKey, monthInfo, loadMonths };
}
